import { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import Play from "./Play";
import { media } from "../media";
import { useTouch } from "../hooks/useTouch";

interface IsLeyout {
  children: any;
  isOpen?: boolean;
  isMyAlbum?: boolean;
}

export default function Layout({ children, isOpen, isMyAlbum }: IsLeyout) {
  const vh = useMemo(() => window.innerHeight * 0.01, []);
  const width = window.innerWidth;
  const height = window.innerHeight;

  const [isPlay, setIsPlay] = useState(false);

  const handleNext = () => {
    if (window.innerWidth > 767) return;
    setIsPlay(() => true);
    (document.activeElement as HTMLElement).blur();
  };
  const handlePrev = () => {
    if (window.innerWidth > 767) return;
    if (isPlay) {
      setIsPlay(() => false);
    }
    // else if (!isPlay) {
    //   nav(-1);
    // }

    (document.activeElement as HTMLElement).blur();
  };

  useEffect(() => {
    if (isOpen) {
      handleNext();
    }
  }, [isOpen]);

  const { onTouchStart, onTouchEnd } = useTouch(handleNext, handlePrev);

  return (
    <LayoutWrap
      vh={vh}
      width={width}
      height={height}
      isPlay={isPlay}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      <div className="LayoutInner">
        <main>{children}</main>
      </div>
      <div className="PlayWrap">
        <Play handlePrev={handlePrev} />
      </div>
    </LayoutWrap>
  );
}

interface IsLayoutWrap {
  vh: number;
  width: number;
  height: number;
  isPlay: boolean;
}

const LayoutWrap = styled.div<IsLayoutWrap>`
  display: flex;
  position: fixed;
  width: calc(100vw + 100vw);

  transition: all 0.24s ease-out;
  left: ${({ isPlay }) => (isPlay ? "-100vw" : "0px")};
  .LayoutInner {
    main {
      height: ${({ vh }) => `calc(${vh} * 100px)`};
      width: 100%;
      ${media.desktop`
        width: 393px;
  `}
    }
  }
  .PlayWrap {
    height: ${({ vh }) => `calc(${vh} * 100px)`};
    width: 100%;
  }
`;
